import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'sd-accordion-content',
  standalone: true,
  templateUrl: './accordion-content.component.html',
  styleUrls: ['./accordion-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SdAccordionContentComponent {
  @Input() @HostBinding('attr.id') id?: string;

  @Input() @HostBinding('attr.aria-labelledby') labelledBy?: string;

  @HostBinding('attr.role') role = 'region';
}
